import reducer from "./reducer";
export { default as MyPeople } from "./components/index";
export { default as myPeopleReducerName } from "./constants";
export default reducer;
